var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.209 3.04271C16.8652 3.19896 17.334 3.79271 17.334 4.44896C17.334 12.1365 11.084 18.324 3.42773 18.324C2.77148 18.324 2.17773 17.8865 2.02148 17.2302L1.36523 14.2927C1.20898 13.6052 1.55273 12.9177 2.17773 12.6365L5.36523 11.2927C5.92773 11.0427 6.61523 11.199 7.02148 11.699L8.05273 12.949C9.67773 12.0427 11.0527 10.699 11.9277 9.07396L10.6777 8.04271C10.1777 7.63646 10.0215 6.94896 10.2715 6.38646L11.6465 3.19896C11.8965 2.57396 12.584 2.23021 13.2715 2.38646L16.209 3.04271ZM3.49023 16.824C10.2715 16.7927 15.8027 11.2927 15.834 4.51146L12.9902 3.85521L11.6777 6.91771L13.8027 8.66771C12.334 11.7615 10.7402 13.3552 7.64648 14.824L5.89648 12.699L2.83398 14.0115L3.49023 16.824Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlack);
export default __webpack_public_path__ + "static/media/phoneBlack.1f6cef5a15a33ebace1fa611804f1872.svg";
export { ForwardRef as ReactComponent };